
import { defineComponent, PropType } from 'vue';
import { PARKING_SORT_OPTIONS, FEATURE_FLAGS } from '@white-label-configuration/constants';
import { closeModal, popstateEventHandler, pushModalState } from '@white-label-helper/helper-history-modal';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
import { initFeefoReviews, updateFeefoStyles } from '@white-label-helper/init-feefo-reviews';
import { useScreenSize } from '@white-label-helper/shared-composables';

export default defineComponent({
  name: 'SearchParkingSort',

  components: {
    IconArrowDown: () => import('@white-label-icon/icon-arrow-down'),
    IconButton: () => import('@white-label-icon/icon-button'),
    IconCheck: () => import('@white-label-icon/icon-check'),
    IconSort: () => import('@white-label-icon/icon-sort'),
    IconClose: () => import('@white-label-icon/icon-close'),
  },

  setup() {
    const { isMobileResolution, isTabletResolution } = useScreenSize();
    return { isMobileResolution, isTabletResolution };
  },

  props: {
    sortOptions: {
      type: Array as PropType<string[]>,
      required: true
    },

    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      removePopstateHandler: null,
      listShown: false,
      PARKING_SORT_OPTIONS
    };
  },

  computed: {
    isScrollLocked(): boolean {
      return (this.isMobileResolution || this.isTabletResolution) && this.listShown;
    }
  },

  watch: {
    listShown: {
      handler(value) {
        if (value) {
          pushModalState('sort');
        } else {
          closeModal();
        }
      }
    }
  },

  mounted() {
    this.removePopstateHandler = popstateEventHandler('sort', () => this.listShown = false);
  },

  beforeDestroy() {
    if (this.removePopstateHandler) {
      this.removePopstateHandler();
    }
  },

  methods: {
    onOptionSelect(option: string): void {
      this.$emit('input', option);
      this.listShown = false;

      if (!getFeatureFlag('ecom-3559-fee-fo-api-integration')) {
        initFeefoReviews();
        updateFeefoStyles();
      }
    }
  }
});
